import React, { useContext, useState } from "react";
import { Switch, withRouter } from "react-router-dom";
import List from "./List";
import Invoice from "./Invoice";
import { InvoicingProvider } from "./InvoicingContext";
import AppContext from "AppContext";
import PrivateRoute from "components/PrivateRoute";
import ReportPage from "./ReportPage";

function Invoicing() {
    const [isUserCreating, setIsUserCreating] = useState(false);
    const {
        api: {
            Invoicing: { Invoices, InvoiceDetails },
            Management: { Customers },
            Settings: { Products },
        },
    } = useContext(AppContext);
    return (
        <InvoicingProvider value={{ Invoices, InvoiceDetails, Products, Customers, isUserCreating, setIsUserCreating }}>
            <Switch>
                <PrivateRoute exact path="/invoicing" component={List} />
                <PrivateRoute exact path="/invoicing/add" render={(props) => <Invoice {...props} mode="add" title="Create Invoice" />} />
                <PrivateRoute
                    exact
                    path="/invoicing/:id/update"
                    render={(props) => <Invoice {...props} mode="update" title="Modify Invoice" />}
                />
                <PrivateRoute exact path="/invoicing/:id/report" component={ReportPage} />
            </Switch>
        </InvoicingProvider>
    );
}

export default withRouter(Invoicing);
